
// helper to convert a list of strings into a table
export const listToLookupTable = (list, selfReference = true) => {
	return list.reduce((l,v) => {
		l[v] = selfReference ? v : true
		return l
	}, {})
}

export const getBinForValue = (value, lowerBound, upperBound, numBins) => {
	if (value < lowerBound)
		return 0 // restrict to range
	if (value > upperBound)
		return numBins-1 // restrict to range

	const inc = (upperBound-lowerBound) / numBins
	for (var i=0; i<numBins; i++) {
		if (value < (lowerBound + inc * (i+1)))
			return i
	}
}

export const hslaRemoveAlpha = hsla => {
	if (hsla.includes('hsla(')) {
		const vals = hsla.replace('hsla(', '').replace(')').replace(/\s/g, '').split(',')
		return 'hsl(' + vals[0] + ',' + vals[1] + ',' + vals[2] + ')'
	}
	return hsla
}


export const mergeInUpdatedFieldBounds = (existingFilterFieldBounds, updatedFieldFilterBounds_nonObjectFormat) => {
	Object.keys(updatedFieldFilterBounds_nonObjectFormat).forEach((updatedFieldName) => {
		const newFilterBounds = updatedFieldFilterBounds_nonObjectFormat[updatedFieldName]
		
		existingFilterFieldBounds[updatedFieldName] = {
			...existingFilterFieldBounds[updatedFieldName],
			filterBounds: newFilterBounds, // Note the structure is { fieldName: [lowerBounds, upperBound], ... }
		}
	})
	
	return {...existingFilterFieldBounds}
}
